export const LANGS = [
  { code: "fr", label: "Français" },
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "ru", label: "Русский" },
  { code: "es", label: "Español" },
  { code: "vi", label: "Tiếng Việt" },
  { code: "th", label: "ไทย" },
  { code: "hr", label: "Hrvatski" },
];

export const translations = {
  fr: {
    nav: {
      member: "Espace membre",
      how: "Comment ça marche",
      structures: "Structures",
      faq: "FAQ",
      register: "S'inscrire gratuitement",
    },
    hype: {
      eyebrow: "Pourquoi c'est maintenant",
      lineA: "UN PROJET UNIQUE.",
      lineB: "JAMAIS VU AVANT.",
      lineC: "VOTRE POSITION, POUR LA VIE.",
      sub: "PreNet ouvre la porte d'un réseau mondial qui se construit en ce moment même — les premiers arrivés y prennent racine.",
    },
    prelaunch: {
      barBrand: "ULTIMATE PRELAUNCH",
      countdownLabel: "COMPTE À REBOURS LANCÉ",
      launched: "C'EST LANCÉ !",
      titleA: "DERNIERS JOURS POUR REJOINDRE",
      titleB: "LA POWERLINE !",
      subtitle: "UNE NOUVELLE AVENTURE MONDIALE SE PRÉPARE !",
      body: "D'ici quelques jours, les premières positions seront attribuées manuellement dans le Back Office. C'est le moment de prendre position !",
      check1: "Inscription 100 % GRATUITE",
      check2: "Aucun achat nécessaire pour s'inscrire",
      check3: "Partagez votre lien de parrainage",
      check4: "Positionnement dans la future structure mondiale, selon les règles du projet",
      reveal: "LES PREMIÈRES INFORMATIONS SERONT DÉVOILÉES :",
      chip1: "Premières vidéos de présentation",
      chip2: "Documents PDF explicatifs",
      chip3: "Découverte du Back Office",
      chip4: "Présentation progressive du concept international",
      cta: "REJOINDRE LA POWERLINE",
      share: "Partagez votre lien de parrainage et invitez vos contacts !",
      disclaimer: "Les modalités définitives du projet et les éventuelles rémunérations restent à préciser. L'inscription ne garantit aucun revenu.",
    },
    hero: {
      eyebrow: "Pré-lancement · Inscription gratuite",
      liveLabel: "Nouveaux membres",
      liveNote: "Flux illustratif",
      urgent: "Pré-lancement ouvert — l'ordre d'entrée définit le positionnement mondial",
      powerlineNote: "Réfléchissez, mais entre temps, les nouveaux arrivent dans la powerline avant vous !",
      realJoin: "vient de rejoindre le réseau",
      invitedBy: "Invité par",
      youWillBe: "Vous serez",
      titleA: "Bâtissez une fois.",
      titleB: "Connecté pour la vie.",
      sub: "PreNet est la couche communautaire. Les personnes d'abord, les tendances ensuite. Prenez votre position avant que la prochaine opportunité n'arrive.",
      ctaPrimary: "S'inscrire gratuitement",
      ctaSecondary: "FAQ",
      positioned: "déjà positionnés dans le réseau",
      statStructures: "structures connectées",
      statFree: "inscription gratuite",
    },
    marquee: [
      "Les personnes d'abord, les tendances ensuite",
      "Inscription gratuite",
      "La communauté d'abord, les opportunités ensuite",
      "Une inscription · Quatre structures",
      "Bâtissez une fois. Connecté pour la vie.",
    ],
    shift: {
      eyebrow: "Une question différente",
      title: "Et si la prochaine tendance n'était pas le produit ?",
      sub: "Pendant des années, tout le monde a attendu le prochain grand truc. PreNet part d'une autre question : qu'est-ce que vous bâtissez avant qu'il arrive ?",
      oldTitle: "L'ancien modèle",
      oldItems: [
        "Nouvelle entreprise. Nouveau logo. Nouvelle promesse.",
        "Nouveau produit. Une nouvelle présentation à apprendre.",
        "Les mêmes contacts. Les mêmes doutes.",
        "Tout reconstruire de zéro. Encore.",
      ],
      newTitle: "PreNet change l'ordre",
      newItems: [
        "La communauté d'abord. Les opportunités ensuite.",
        "Votre position reste quand les projets changent.",
        "Une inscription, quatre structures.",
        "Le réseau ne suit plus l'opportunité : l'opportunité vient au réseau.",
      ],
      quote: "Le problème n'a jamais été votre effort. C'était l'ordre.",
    },
    structures: {
      eyebrow: "Une seule inscription",
      title: "Plusieurs structures.",
      sub: "Avec une seule inscription gratuite, PreNet vous positionne dans plusieurs structures organisationnelles.",
      cards: [
        {
          name: "Matrice 3x10",
          desc: "Trois positions sous chaque personne, dix niveaux de profondeur. Elle se remplit niveau par niveau et organise la profondeur.",
        },
        {
          name: "Powerline / Ligne globale",
          desc: "Une seule ligne qui grandit avec chaque inscription dans le monde. Elle porte le mouvement global.",
        },
        {
          name: "Uniniveau",
          desc: "Un arbre ouvert qui part de votre nœud, basé sur l'activité directe.",
        },
        {
          name: "Binaire",
          desc: "Deux branches équilibrées qui structurent l'expansion de votre équipe.",
        },
      ],
      vEyebrow: "La suite",
      vTitle: "La porte vers ce qui vient.",
      vSub: "PreNet est conçu comme la couche communautaire des prochains lancements. Vous décidez de ce que vous activez.",
      vItems: [
        "Santé & bien-être",
        "Gaming & divertissement",
        "IA générative",
        "Éducation & expériences",
        "Solutions logicielles",
      ],
      vNote: "En préparation · Opt-in uniquement",
    },
    faq: {
      eyebrow: "Vraies questions",
      title: "Des réponses sans pression.",
      items: [
        {
          q: "Encore un MLM de plus ?",
          a: "PreNet ne commence pas avec un produit. Il commence avec une communauté qui reste avec vous quand les projets changent.",
        },
        {
          q: "Je suis déjà trop tard ?",
          a: "Le réseau se forme maintenant. La structure se construit dans l'ordre, et votre position commence quand vous vous inscrivez.",
        },
        {
          q: "Je dois acheter quelque chose ?",
          a: "L'inscription est gratuite. Chaque projet ne s'active que par opt-in, quand vous le décidez.",
        },
        {
          q: "Et si un projet échoue ?",
          a: "C'est l'idée derrière PreNet : si un projet change, la communauté n'a pas à disparaître avec lui.",
        },
      ],
    },
    advantage: {
      "eyebrow": "Avantage pré-lancement",
      "title": "L'ordre d'entrée est l'avantage.",
      "sub": "Pas de compte à rebours, pas d'urgence artificielle. Un seul fait : le réseau se construit dans l'ordre. Votre position mondiale commence dès votre inscription — et chaque inscription dans le monde prolonge la ligne.",
      "cards": [
            {
                  "name": "Position mondiale",
                  "desc": "Votre place dans la Powerline / Ligne globale est fixée par l'ordre d'inscription. La ligne grandit avec chaque membre, partout dans le monde."
            },
            {
                  "name": "Quatre structures d'un coup",
                  "desc": "Une seule inscription gratuite vous positionne en même temps dans la Matrice 3x10, la Powerline, l'Uniniveau et le Binaire."
            },
            {
                  "name": "Rien à payer",
                  "desc": "L'inscription est gratuite et les futurs projets sont en opt-in uniquement. Votre seul investissement aujourd'hui : dix minutes."
            }
      ],
      "strip": "Aucun compte à rebours. L'ordre d'entrée compte — sécurisez votre position maintenant."
},
    form: {
      eyebrow: "Votre position",
      title: "Dix minutes. Décidez.",
      sub: "L'inscription est gratuite. Chaque projet est en opt-in. Votre position commence quand vous vous inscrivez.",
      name: "Nom complet",
      email: "Email",
      username: "Nom d'utilisateur",
      sponsor: "Nom d'utilisateur du parrain",
      sponsorOptional: "facultatif",
      phName: "Alex Martin",
      phEmail: "alex@email.com",
      phUsername: "alexmartin",
      phSponsor: "le pseudo de la personne qui vous a invité",
      country: "Pays",
      phCountry: "Choisir un pays",
      errCountry: "Choisissez votre pays dans la liste.",
      submit: "S'inscrire gratuitement",
      submitting: "Sécurisation de votre position…",
      successTitle: "Position sécurisée.",
      successBody: "Bienvenue dans le réseau. Votre nom d'utilisateur est réservé.",
      positionLabel: "Votre position",
      again: "Inscrire une autre personne",
      shareTitle: "Faites passer",
      shareText: "Je viens de sécuriser ma position dans PreNet — inscription gratuite au pré-lancement. L'ordre d'entrée compte :",
      shareCopied: "Lien copié !",
      welcomeLink: "Voir ma page de bienvenue",
      referralLinkLabel: "Votre lien de parrainage",
      invitedBy: "Invité par",
      errName: "Veuillez saisir votre nom complet.",
      errEmail: "Veuillez saisir un email valide.",
      errEmailTaken: "Cet email est déjà inscrit.",
      errUsername: "Nom d'utilisateur : 3 à 24 caractères, lettres, chiffres ou underscore.",
      errUsernameTaken: "Ce nom d'utilisateur est déjà pris.",
      errSponsor: "Parrain invalide : 3 à 24 caractères, lettres, chiffres ou underscore.",
      errGeneric: "Une erreur est survenue. Veuillez réessayer.",
      note: "Inscription gratuite. Chaque projet est en opt-in. Vous décidez.",
    },
    member: {
      loginTitle: "Espace membre",
      dashLink: "Voir mes affiliés",      loginSub: "Connectez-vous avec votre pseudo et votre email d'inscription pour voir vos filleuls directs.",
      userLabel: "Votre pseudo",
      emailLabel: "Votre email d'inscription",
      loginBtn: "Accéder à mon tableau",
      loginError: "Pseudo ou email inconnu. Vérifiez vos informations d'inscription.",
      dashSub: "Voici les personnes inscrites avec votre lien de parrainage :",
      yourLink: "Votre lien de parrainage",
      copy: "Copier",
      copied: "Copié !",
      directs: "filleuls directs",
      noDirects: "Aucun filleul pour le moment. Partagez votre lien pour construire votre réseau !",
      colName: "Nom",
      colEmail: "Email",
      colUsername: "Pseudo",
      colCountry: "Pays",
      colDate: "Inscrit le",
      position: "Position",
      refresh: "Actualiser",
      logout: "Déconnexion",
    },
    welcome: {
      videoTitle: "Regardez la vidéo de bienvenue",
      home: "Retour à l'accueil",
      title: "Bienvenue, {name}.",
      sub: "Ta position est sécurisée. Cette page est ta preuve de pré-lancement — partage-la avec ton réseau.",
      positionLabel: "Ta position",
      memberLabel: "membre du réseau",
      placedUnder: "Vous êtes placé sous",
      notFound: "Ce pseudo n'est pas encore inscrit.",
      notFoundCta: "Inscription gratuite",
    },
    footer: {
      tagline: "Bâtissez une fois. Connecté pour la vie.",
      disclaimer: "Page de pré-lancement. Les noms et chiffres affichés sont illustratifs.",
      rights: "© 2026 PreNet · The Ultimate Network",
      admin: "Espace admin",
    },
  },
  en: {
    nav: {
      member: "Member area",
      how: "How it works",
      structures: "Structures",
      faq: "FAQ",
      register: "Register free",
    },
    hype: {
      eyebrow: "Why now",
      lineA: "A ONE-OF-A-KIND PROJECT.",
      lineB: "NEVER SEEN BEFORE.",
      lineC: "YOUR POSITION, FOR LIFE.",
      sub: "PreNet opens the door to a global network being built right now — the first arrivals are already putting down roots.",
    },
    prelaunch: {
      barBrand: "ULTIMATE PRELAUNCH",
      countdownLabel: "COUNTDOWN RUNNING",
      launched: "IT'S LIVE!",
      titleA: "FINAL DAYS TO JOIN",
      titleB: "THE POWERLINE!",
      subtitle: "A NEW GLOBAL ADVENTURE IS BEING PREPARED!",
      body: "Within a few days, the first positions will be manually assigned in the Back Office. Now is the time to take your spot!",
      check1: "100% FREE registration",
      check2: "No purchase required to register",
      check3: "Share your referral link",
      check4: "Positioning in the future global structure, according to the project's rules",
      reveal: "FIRST INFORMATION TO BE REVEALED:",
      chip1: "First presentation videos",
      chip2: "Explanatory PDF documents",
      chip3: "Back Office discovery",
      chip4: "Progressive introduction of the international concept",
      cta: "JOIN THE POWERLINE",
      share: "Share your referral link and invite your contacts!",
      disclaimer: "The final details of the project and any potential earnings remain to be specified. Registration does not guarantee any income.",
    },
    hero: {
      eyebrow: "Pre-launch · Free registration",
      liveLabel: "New members",
      liveNote: "Illustrative feed",
      urgent: "Pre-launch open — entry order defines global positioning",
      powerlineNote: "Think it over — meanwhile, newcomers are joining the powerline ahead of you!",
      realJoin: "just joined the network",
      invitedBy: "Invited by",
      youWillBe: "You'll be",
      titleA: "Build once.",
      titleB: "Connected for life.",
      sub: "PreNet is the community layer. People first, trends second. Take your position before the next opportunity arrives.",
      ctaPrimary: "Register free",
      ctaSecondary: "FAQ",
      positioned: "already positioned in the network",
      statStructures: "connected structures",
      statFree: "free registration",
    },
    marquee: [
      "People first, trends second",
      "Free registration",
      "Community first, opportunities after",
      "One registration · Four structures",
      "Build once. Connected for life.",
    ],
    shift: {
      eyebrow: "A different question",
      title: "What if the next trend is not the product?",
      sub: "For years, people have waited for the next big thing. PreNet starts from a different question: what are you building before it arrives?",
      oldTitle: "The old model",
      oldItems: [
        "New company. New logo. New promise.",
        "New product. Another presentation to learn.",
        "The same contacts. The same doubts.",
        "Rebuild everything from zero. Again.",
      ],
      newTitle: "PreNet changes the order",
      newItems: [
        "Community first. Then the opportunities.",
        "Your position stays when projects change.",
        "One registration, four structures.",
        "The network no longer follows the opportunity. The opportunity comes to the network.",
      ],
      quote: "The problem was never your effort. It was the order.",
    },
    structures: {
      eyebrow: "One registration",
      title: "Multiple structures.",
      sub: "With a single free registration, PreNet positions you inside several organisational structures.",
      cards: [
        {
          name: "3x10 Matrix",
          desc: "Three positions under each person, ten levels deep. It fills level by level and organises depth.",
        },
        {
          name: "Powerline / Global Line",
          desc: "A single line that grows with every registration worldwide. It drives the global movement.",
        },
        {
          name: "Unilevel",
          desc: "An open tree that starts from your node, based on direct activity.",
        },
        {
          name: "Binary",
          desc: "Two balanced branches that give structure to your team's expansion.",
        },
      ],
      vEyebrow: "What's next",
      vTitle: "The door to what's next.",
      vSub: "PreNet is built as the community layer for future launches. You decide what you activate.",
      vItems: [
        "Health & wellness",
        "Gaming & entertainment",
        "Generative AI",
        "Education & experiences",
        "Software solutions",
      ],
      vNote: "In preparation · Opt-in only",
    },
    faq: {
      eyebrow: "Real questions",
      title: "Answers without pressure.",
      items: [
        {
          q: "Is it just another MLM?",
          a: "PreNet does not start with a product. It starts with a community that stays with you when projects change.",
        },
        {
          q: "Am I already too late?",
          a: "The network is forming now. The structure is built in order, and your position starts when you register.",
        },
        {
          q: "Do I have to buy anything?",
          a: "Registration is free. Each project is activated only by opt-in, when you decide.",
        },
        {
          q: "What if a project fails?",
          a: "That is the idea behind PreNet: if a project changes, the community does not have to disappear with it.",
        },
      ],
    },
    advantage: {
      "eyebrow": "Pre-launch advantage",
      "title": "The order of entry is the advantage.",
      "sub": "No countdowns, no artificial urgency. One fact: the network is built in order. Your global position starts the moment you register — and every registration worldwide extends the line.",
      "cards": [
            {
                  "name": "Global positioning",
                  "desc": "Your place in the Powerline / Global Line is set by the order of registration. The line grows with every member, everywhere in the world."
            },
            {
                  "name": "Four structures at once",
                  "desc": "A single free registration positions you in the 3x10 Matrix, Powerline, Unilevel and Binary at the same time."
            },
            {
                  "name": "Nothing to pay",
                  "desc": "Registration is free and future projects are opt-in only. Your only investment today: ten minutes."
            }
      ],
      "strip": "No countdown. Entry order matters — secure your position now."
},
    form: {
      eyebrow: "Your position",
      title: "Take ten minutes. Decide.",
      sub: "Registration is free. Every project is opt-in. Your position starts when you register.",
      name: "Full name",
      email: "Email",
      username: "Username",
      sponsor: "Sponsor username",
      sponsorOptional: "optional",
      phName: "Alex Martin",
      phEmail: "alex@email.com",
      phUsername: "alexmartin",
      phSponsor: "the username of the person who invited you",
      country: "Country",
      phCountry: "Select a country",
      errCountry: "Please select your country from the list.",
      submit: "Register free",
      submitting: "Securing your position…",
      successTitle: "Position secured.",
      successBody: "Welcome to the network. Your username is reserved.",
      positionLabel: "Your position",
      again: "Register another person",
      shareTitle: "Spread the word",
      shareText: "I just secured my position in PreNet — free pre-launch registration. Entry order matters:",
      shareCopied: "Link copied!",
      welcomeLink: "View my welcome page",
      referralLinkLabel: "Your referral link",
      invitedBy: "Invited by",
      errName: "Please enter your full name.",
      errEmail: "Please enter a valid email address.",
      errEmailTaken: "This email is already registered.",
      errUsername: "Username: 3 to 24 characters, letters, numbers or underscore.",
      errUsernameTaken: "This username is already taken.",
      errSponsor: "Invalid sponsor: 3 to 24 characters, letters, numbers or underscore.",
      errGeneric: "Something went wrong. Please try again.",
      note: "Free registration. Every project is opt-in. You decide.",
    },
    member: {
      loginTitle: "Member area",
      dashLink: "See my affiliates",      loginSub: "Log in with your username and registration email to see your direct referrals.",
      userLabel: "Your username",
      emailLabel: "Your registration email",
      loginBtn: "Open my dashboard",
      loginError: "Unknown username or email. Check your registration details.",
      dashSub: "Here are the people who registered with your referral link:",
      yourLink: "Your referral link",
      copy: "Copy",
      copied: "Copied!",
      directs: "direct referrals",
      noDirects: "No referrals yet. Share your link to build your network!",
      colName: "Name",
      colEmail: "Email",
      colUsername: "Username",
      colCountry: "Country",
      colDate: "Registered on",
      position: "Position",
      refresh: "Refresh",
      logout: "Log out",
    },
    welcome: {
      videoTitle: "Watch the welcome video",
      home: "Back to home",
      title: "Welcome, {name}.",
      sub: "Your position is secured. This page is your pre-launch proof — share it with your network.",
      positionLabel: "Your position",
      memberLabel: "member of the network",
      placedUnder: "You are placed under",
      notFound: "This username is not registered (yet).",
      notFoundCta: "Register free",
    },
    footer: {
      tagline: "Build once. Connected for life.",
      disclaimer: "Pre-launch page. Names and figures shown are illustrative.",
      rights: "© 2026 PreNet · The Ultimate Network",
      admin: "Admin area",
    },
  },
  de: {
    nav: {
      member: "Mitglieder",
      how: "So funktioniert es",
      structures: "Strukturen",
      faq: "FAQ",
      register: "Kostenlos registrieren",
    },
    hype: {
      eyebrow: "Warum jetzt",
      lineA: "EIN EINZIGARTIGES PROJEKT.",
      lineB: "NOCH NIE GESEHEN.",
      lineC: "IHRE POSITION, FÜRS LEBEN.",
      sub: "PreNet öffnet die Tür zu einem globalen Netzwerk, das gerade entsteht — die Ersten verwurzeln sich bereits darin.",
    },
    prelaunch: {
      barBrand: "ULTIMATE PRELAUNCH",
      countdownLabel: "COUNTDOWN LÄUFT",
      launched: "ES IST GESTARTET!",
      titleA: "LETZTE TAGE, UM DER",
      titleB: "POWERLINE BEIZUTRETEN!",
      subtitle: "EIN NEUES GLOBALES ABENTEUER ENTSTEHT!",
      body: "In den nächsten Tagen werden die ersten Positionen manuell im Back Office vergeben. Jetzt ist der Moment, sich zu positionieren!",
      check1: "Registrierung 100 % KOSTENLOS",
      check2: "Kein Kauf zur Registrierung nötig",
      check3: "Teilen Sie Ihren Empfehlungslink",
      check4: "Positionierung in der künftigen globalen Struktur nach den Regeln des Projekts",
      reveal: "DIE ERSTEN INFORMATIONEN WERDEN ENTHÜLLT:",
      chip1: "Erste Präsentationsvideos",
      chip2: "Erklärende PDF-Dokumente",
      chip3: "Back-Office-Entdeckung",
      chip4: "Schrittweise Vorstellung des internationalen Konzepts",
      cta: "DER POWERLINE BEITRETEN",
      share: "Teilen Sie Ihren Empfehlungslink und laden Sie Ihre Kontakte ein!",
      disclaimer: "Die endgültigen Modalitäten des Projekts und mögliche Vergütungen stehen noch aus. Die Registrierung garantiert kein Einkommen.",
    },
    hero: {
      eyebrow: "Vor dem Start · Kostenlose Registrierung",
      liveLabel: "Neue Mitglieder",
      liveNote: "Illustrativer Feed",
      urgent: "Vorab-Phase offen — die Reihenfolge des Eintritts definiert die globale Positionierung",
      powerlineNote: "Denk in Ruhe nach — aber währenddessen landen Neueinsteiger vor dir in der Powerline!",
      realJoin: "ist gerade dem Netzwerk beigetreten",
      invitedBy: "Eingeladen von",
      youWillBe: "Du wirst",
      titleA: "Einmal aufbauen.",
      titleB: "Verbunden fürs Leben.",
      sub: "PreNet ist die Community-Schicht. Menschen zuerst, Trends danach. Sichere deine Position, bevor die nächste Chance kommt.",
      ctaPrimary: "Kostenlos registrieren",
      ctaSecondary: "FAQ",
      positioned: "bereits im Netzwerk positioniert",
      statStructures: "verbundene Strukturen",
      statFree: "kostenlose Registrierung",
    },
    marquee: [
      "Menschen zuerst, Trends danach",
      "Kostenlose Registrierung",
      "Community zuerst, Chancen danach",
      "Eine Registrierung · Vier Strukturen",
      "Einmal aufbauen. Verbunden fürs Leben.",
    ],
    shift: {
      eyebrow: "Eine andere Frage",
      title: "Was, wenn der nächste Trend nicht das Produkt ist?",
      sub: "Jahrelang hat man auf das nächste große Ding gewartet. PreNet beginnt mit einer anderen Frage: Was baust du auf, bevor es kommt?",
      oldTitle: "Das alte Modell",
      oldItems: [
        "Neue Firma. Neues Logo. Neues Versprechen.",
        "Neues Produkt. Wieder etwas zu lernen.",
        "Dieselben Kontakte. Dieselben Zweifel.",
        "Alles wieder von Null aufbauen.",
      ],
      newTitle: "PreNet dreht die Reihenfolge",
      newItems: [
        "Community zuerst. Dann die Chancen.",
        "Deine Position bleibt, wenn Projekte wechseln.",
        "Eine Registrierung, vier Strukturen.",
        "Das Netzwerk folgt nicht mehr der Chance. Die Chance kommt zum Netzwerk.",
      ],
      quote: "Das Problem war nie deine Anstrengung. Es war die Reihenfolge.",
    },
    structures: {
      eyebrow: "Eine Registrierung",
      title: "Mehrere Strukturen.",
      sub: "Mit einer einzigen kostenlosen Registrierung positioniert PreNet dich in mehreren Organisationsstrukturen.",
      cards: [
        {
          name: "3x10 Matrix",
          desc: "Drei Positionen unter jeder Person, zehn Ebenen tief. Sie füllt sich Ebene für Ebene und strukturiert die Tiefe.",
        },
        {
          name: "Powerline / Globale Linie",
          desc: "Eine einzige Linie, die mit jeder Registrierung weltweit wächst. Sie trägt die globale Bewegung.",
        },
        {
          name: "Unilevel",
          desc: "Ein offener Baum ab deinem Knoten, basierend auf direkter Aktivität.",
        },
        {
          name: "Binär",
          desc: "Zwei ausgewogene Zweige, die der Expansion deines Teams Struktur geben.",
        },
      ],
      vEyebrow: "Was kommt",
      vTitle: "Die Tür zum Nächsten.",
      vSub: "PreNet ist als Community-Schicht für künftige Launches gebaut. Du entscheidest, was du aktivierst.",
      vItems: [
        "Gesundheit & Wellness",
        "Gaming & Unterhaltung",
        "Generative KI",
        "Bildung & Erlebnisse",
        "Software-Lösungen",
      ],
      vNote: "In Vorbereitung · Nur Opt-in",
    },
    faq: {
      eyebrow: "Echte Fragen",
      title: "Antworten ohne Druck.",
      items: [
        {
          q: "Schon wieder ein MLM?",
          a: "PreNet startet nicht mit einem Produkt. Es startet mit einer Community, die bleibt, wenn Projekte wechseln.",
        },
        {
          q: "Bin ich schon zu spät?",
          a: "Das Netzwerk entsteht jetzt. Die Struktur wird der Reihe nach aufgebaut, und deine Position beginnt mit der Registrierung.",
        },
        {
          q: "Muss ich etwas kaufen?",
          a: "Die Registrierung ist kostenlos. Jedes Projekt wird nur per Opt-in aktiviert, wenn du es entscheidest.",
        },
        {
          q: "Was, wenn ein Projekt scheitert?",
          a: "Genau das ist die Idee hinter PreNet: Wenn ein Projekt wechselt, muss die Community nicht mit ihm verschwinden.",
        },
      ],
    },
    advantage: {
      "eyebrow": "Vorab-Vorteil",
      "title": "Die Reihenfolge des Eintritts ist der Vorteil.",
      "sub": "Keine Countdowns, keine künstliche Dringlichkeit. Ein Fakt: Das Netzwerk wird der Reihe nach aufgebaut. Deine globale Position beginnt mit der Registrierung — und jede Registrierung weltweit verlängert die Linie.",
      "cards": [
            {
                  "name": "Globale Positionierung",
                  "desc": "Dein Platz in der Powerline / Globalen Linie wird durch die Reihenfolge der Registrierung bestimmt. Die Linie wächst mit jedem Mitglied, überall auf der Welt."
            },
            {
                  "name": "Vier Strukturen auf einmal",
                  "desc": "Eine einzige kostenlose Registrierung positioniert dich gleichzeitig in der 3x10 Matrix, in Powerline, Unilevel und Binär."
            },
            {
                  "name": "Nichts zu zahlen",
                  "desc": "Die Registrierung ist kostenlos, künftige Projekte nur per Opt-in. Deine einzige Investition heute: zehn Minuten."
            }
      ],
      "strip": "Kein Countdown. Die Eintritts-Reihenfolge zählt — sichere jetzt deine Position."
},
    form: {
      eyebrow: "Deine Position",
      title: "Zehn Minuten. Entscheiden.",
      sub: "Die Registrierung ist kostenlos. Jedes Projekt ist Opt-in. Deine Position beginnt mit der Registrierung.",
      name: "Vollständiger Name",
      email: "E-Mail",
      username: "Benutzername",
      sponsor: "Sponsor-Benutzername",
      sponsorOptional: "optional",
      phName: "Alex Martin",
      phEmail: "alex@email.com",
      phUsername: "alexmartin",
      phSponsor: "der Benutzername der Person, die dich eingeladen hat",
      country: "Land",
      phCountry: "Land wählen",
      errCountry: "Wähle dein Land aus der Liste.",
      submit: "Kostenlos registrieren",
      submitting: "Position wird gesichert…",
      successTitle: "Position gesichert.",
      successBody: "Willkommen im Netzwerk. Dein Benutzername ist reserviert.",
      positionLabel: "Deine Position",
      again: "Weitere Person registrieren",
      shareTitle: "Weitersagen",
      shareText: "Ich habe gerade meine Position in PreNet gesichert — kostenlose Vorab-Registrierung. Die Eintritts-Reihenfolge zählt:",
      shareCopied: "Link kopiert!",
      welcomeLink: "Meine Willkommensseite ansehen",
      referralLinkLabel: "Dein Empfehlungslink",
      invitedBy: "Eingeladen von",
      errName: "Bitte gib deinen vollständigen Namen ein.",
      errEmail: "Bitte gib eine gültige E-Mail-Adresse ein.",
      errEmailTaken: "Diese E-Mail ist bereits registriert.",
      errUsername: "Benutzername: 3 bis 24 Zeichen, Buchstaben, Zahlen oder Unterstrich.",
      errUsernameTaken: "Dieser Benutzername ist bereits vergeben.",
      errSponsor: "Ungültiger Sponsor: 3 bis 24 Zeichen, Buchstaben, Zahlen oder Unterstrich.",
      errGeneric: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      note: "Kostenlose Registrierung. Jedes Projekt ist Opt-in. Du entscheidest.",
    },
    member: {
      loginTitle: "Mitgliederbereich",
      dashLink: "Meine Partner ansehen",      loginSub: "Melden Sie sich mit Ihrem Benutzernamen und Ihrer Registrierungs-E-Mail an, um Ihre direkten Empfehlungen zu sehen.",
      userLabel: "Ihr Benutzername",
      emailLabel: "Ihre Registrierungs-E-Mail",
      loginBtn: "Zu meinem Dashboard",
      loginError: "Unbekannter Benutzername oder unbekannte E-Mail. Prüfen Sie Ihre Registrierungsdaten.",
      dashSub: "Das sind die Personen, die sich mit Ihrem Empfehlungslink registriert haben:",
      yourLink: "Ihr Empfehlungslink",
      copy: "Kopieren",
      copied: "Kopiert!",
      directs: "direkte Empfehlungen",
      noDirects: "Noch keine Empfehlungen. Teilen Sie Ihren Link, um Ihr Netzwerk aufzubauen!",
      colName: "Name",
      colEmail: "E-Mail",
      colUsername: "Benutzername",
      colCountry: "Land",
      colDate: "Registriert am",
      position: "Position",
      refresh: "Aktualisieren",
      logout: "Abmelden",
    },
    welcome: {
      videoTitle: "Sehen Sie das Willkommensvideo",
      home: "Zurück zur Startseite",
      title: "Willkommen, {name}.",
      sub: "Deine Position ist gesichert. Diese Seite ist dein Vorab-Nachweis — teile sie mit deinem Netzwerk.",
      positionLabel: "Deine Position",
      memberLabel: "Mitglied im Netzwerk",
      placedUnder: "Du bist platziert unter",
      notFound: "Dieser Benutzername ist noch nicht registriert.",
      notFoundCta: "Kostenlos registrieren",
    },
    footer: {
      tagline: "Einmal aufbauen. Verbunden fürs Leben.",
      disclaimer: "Vorab-Seite. Angezeigte Namen und Zahlen sind illustrativ.",
      rights: "© 2026 PreNet · The Ultimate Network",
      admin: "Admin-Bereich",
    },
  },
  ru: {
    nav: {
      member: "Кабинет",
      how: "Как это работает",
      structures: "Структуры",
      faq: "FAQ",
      register: "Регистрация",
    },
    hype: {
      eyebrow: "Почему именно сейчас",
      lineA: "УНИКАЛЬНЫЙ ПРОЕКТ.",
      lineB: "АНАЛОГОВ НЕ БЫЛО.",
      lineC: "ВАША ПОЗИЦИЯ — НАВСЕГДА.",
      sub: "PreNet открывает дверь в глобальную сеть, которая создаётся прямо сейчас — первые уже пускают в ней корни.",
    },
    prelaunch: {
      barBrand: "ULTIMATE PRELAUNCH",
      countdownLabel: "ОБРАТНЫЙ ОТСЧЁТ ЗАПУЩЕН",
      launched: "СТАРТ СОСТОЯЛСЯ!",
      titleA: "ПОСЛЕДНИЕ ДНИ, ЧТОБЫ",
      titleB: "ПОПАСТЬ В POWERLINE!",
      subtitle: "ГОТОВИТСЯ НОВОЕ ГЛОБАЛЬНОЕ ПРИКЛЮЧЕНИЕ!",
      body: "Через несколько дней первые позиции будут вручную закреплены в Back Office. Сейчас — момент занять своё место!",
      check1: "Регистрация 100 % БЕСПЛАТНАЯ",
      check2: "Для регистрации не нужно ничего покупать",
      check3: "Поделитесь своей реферальной ссылкой",
      check4: "Позиционирование в будущей глобальной структуре по правилам проекта",
      reveal: "ПЕРВАЯ ИНФОРМАЦИЯ БУДЕТ РАСКРЫТА:",
      chip1: "Первые презентационные видео",
      chip2: "Пояснительные PDF-документы",
      chip3: "Знакомство с Back Office",
      chip4: "Постепенная презентация международного концепта",
      cta: "ВОЙТИ В POWERLINE",
      share: "Поделитесь своей реферальной ссылкой и пригласите контакты!",
      disclaimer: "Окончательные условия проекта и возможные вознаграждения ещё уточняются. Регистрация не гарантирует дохода.",
    },
    hero: {
      eyebrow: "Предзапуск · Бесплатная регистрация",
      liveLabel: "Новые участники",
      liveNote: "Иллюстративная лента",
      urgent: "Предзапуск открыт — порядок входа определяет глобальную позицию",
      powerlineNote: "Думай, но тем временем новички занимают место в пауэрлайне впереди тебя!",
      realJoin: "только что присоединился к сети",
      invitedBy: "Приглашён",
      youWillBe: "Вы будете",
      titleA: "Построй один раз.",
      titleB: "Подключён навсегда.",
      sub: "PreNet — это слой сообщества. Люди в первую очередь, тренды — во вторую. Займи свою позицию до прихода следующей возможности.",
      ctaPrimary: "Зарегистрироваться бесплатно",
      ctaSecondary: "FAQ",
      positioned: "уже в позиции в сети",
      statStructures: "связанных структур",
      statFree: "бесплатная регистрация",
    },
    marquee: [
      "Люди в первую очередь, тренды — во вторую",
      "Бесплатная регистрация",
      "Сначала сообщество, потом возможности",
      "Одна регистрация · Четыре структуры",
      "Построй один раз. Подключён навсегда.",
    ],
    shift: {
      eyebrow: "Другой вопрос",
      title: "А если следующий тренд — это не продукт?",
      sub: "Годами все ждали следующего большого проекта. PreNet начинается с другого вопроса: что ты строишь до его прихода?",
      oldTitle: "Старая модель",
      oldItems: [
        "Новая компания. Новый логотип. Новое обещание.",
        "Новый продукт. Снова учить презентацию.",
        "Те же контакты. Те же сомнения.",
        "Всё строить с нуля. Опять.",
      ],
      newTitle: "PreNet меняет порядок",
      newItems: [
        "Сначала сообщество. Потом возможности.",
        "Твоя позиция сохраняется, когда проекты меняются.",
        "Одна регистрация, четыре структуры.",
        "Сеть больше не следует за возможностью. Возможность приходит к сети.",
      ],
      quote: "Проблема никогда не была в твоих усилиях. Проблема была в порядке.",
    },
    structures: {
      eyebrow: "Одна регистрация",
      title: "Несколько структур.",
      sub: "С одной бесплатной регистрацией PreNet ставит тебя сразу в несколько организационных структур.",
      cards: [
        {
          name: "Матрица 3x10",
          desc: "Три позиции под каждым человеком, десять уровней в глубину. Заполняется уровень за уровнем и организует глубину.",
        },
        {
          name: "Пауэрлайн / Глобальная линия",
          desc: "Единая линия, которая растёт с каждой регистрацией по всему миру. Она ведёт глобальное движение.",
        },
        {
          name: "Унивел",
          desc: "Открытое дерево от твоего узла, основанное на прямой активности.",
        },
        {
          name: "Бинар",
          desc: "Две сбалансированные ветви, задающие структуру роста команды.",
        },
      ],
      vEyebrow: "Что дальше",
      vTitle: "Дверь к тому, что грядёт.",
      vSub: "PreNet создаётся как слой сообщества для будущих запусков. Ты решаешь, что активировать.",
      vItems: [
        "Здоровье и велнес",
        "Игры и развлечения",
        "Генеративный ИИ",
        "Образование и впечатления",
        "Программные решения",
      ],
      vNote: "В подготовке · Только по opt-in",
    },
    faq: {
      eyebrow: "Настоящие вопросы",
      title: "Ответы без давления.",
      items: [
        {
          q: "Это очередной MLM?",
          a: "PreNet начинается не с продукта. Он начинается с сообщества, которое остаётся с тобой, когда проекты меняются.",
        },
        {
          q: "Я уже опоздал?",
          a: "Сеть формируется прямо сейчас. Структура строится по порядку, и твоя позиция начинается с регистрацией.",
        },
        {
          q: "Мне нужно что-то покупать?",
          a: "Регистрация бесплатна. Каждый проект активируется только по opt-in, когда ты решаешь.",
        },
        {
          q: "А если проект закроется?",
          a: "Именно в этом идея PreNet: если проект меняется, сообществу не нужно исчезать вместе с ним.",
        },
      ],
    },
    advantage: {
      "eyebrow": "Преимущество предзапуска",
      "title": "Порядок входа — это преимущество.",
      "sub": "Никаких таймеров и искусственной спешки. Один факт: сеть строится по порядку. Твоя глобальная позиция начинается с моментом регистрации — и каждая регистрация в мире продлевает линию.",
      "cards": [
            {
                  "name": "Глобальное позиционирование",
                  "desc": "Твоё место в пауэрлайне / глобальной линии определяется порядком регистрации. Линия растёт с каждым участником по всему миру."
            },
            {
                  "name": "Четыре структуры сразу",
                  "desc": "Одна бесплатная регистрация ставит тебя одновременно в матрицу 3x10, пауэрлайн, унивел и бинар."
            },
            {
                  "name": "Ничего платить не нужно",
                  "desc": "Регистрация бесплатна, будущие проекты — только по opt-in. Единственная инвестиция сегодня: десять минут."
            }
      ],
      "strip": "Никаких таймеров. Порядок входа имеет значение — закрепи свою позицию сейчас."
},
    form: {
      eyebrow: "Твоя позиция",
      title: "Десять минут. Решение.",
      sub: "Регистрация бесплатна. Каждый проект — только по opt-in. Твоя позиция начинается с регистрацией.",
      name: "Полное имя",
      email: "Email",
      username: "Имя пользователя",
      sponsor: "Имя пользователя спонсора",
      sponsorOptional: "необязательно",
      phName: "Алексей Мартин",
      phEmail: "alex@email.com",
      phUsername: "alexmartin",
      phSponsor: "имя пользователя того, кто тебя пригласил",
      country: "Страна",
      phCountry: "Выберите страну",
      errCountry: "Выбери страну из списка.",
      submit: "Зарегистрироваться бесплатно",
      submitting: "Закрепляем твою позицию…",
      successTitle: "Позиция закреплена.",
      successBody: "Добро пожаловать в сеть. Твоё имя пользователя зарезервировано.",
      positionLabel: "Твоя позиция",
      again: "Зарегистрировать ещё одного человека",
      shareTitle: "Расскажи другим",
      shareText: "Я только что закрепил позицию в PreNet — бесплатная регистрация в предзапуске. Порядок входа имеет значение:",
      shareCopied: "Ссылка скопирована!",
      welcomeLink: "Открыть мою страницу приветствия",
      referralLinkLabel: "Твоя реферальная ссылка",
      invitedBy: "Приглашение от",
      errName: "Введи своё полное имя.",
      errEmail: "Введи корректный email.",
      errEmailTaken: "Этот email уже зарегистрирован.",
      errUsername: "Имя пользователя: от 3 до 24 символов — буквы, цифры или подчёркивание.",
      errUsernameTaken: "Это имя пользователя уже занято.",
      errSponsor: "Неверный спонсор: от 3 до 24 символов — буквы, цифры или подчёркивание.",
      errGeneric: "Что-то пошло не так. Попробуй ещё раз.",
      note: "Регистрация бесплатна. Каждый проект — только по opt-in. Ты решаешь.",
    },
    member: {
      loginTitle: "Кабинет участника",
      dashLink: "Мои партнёры",      loginSub: "Войдите с вашим ником и email регистрации, чтобы увидеть ваших прямых партнёров.",
      userLabel: "Ваш ник",
      emailLabel: "Ваш email регистрации",
      loginBtn: "Открыть мой кабинет",
      loginError: "Неизвестный ник или email. Проверьте данные регистрации.",
      dashSub: "Вот люди, зарегистрировавшиеся по вашей реферальной ссылке:",
      yourLink: "Ваша реферальная ссылка",
      copy: "Копировать",
      copied: "Скопировано!",
      directs: "прямых партнёров",
      noDirects: "Пока нет партнёров. Делитесь ссылкой и стройте свою сеть!",
      colName: "Имя",
      colEmail: "Email",
      colUsername: "Ник",
      colCountry: "Страна",
      colDate: "Дата регистрации",
      position: "Позиция",
      refresh: "Обновить",
      logout: "Выйти",
    },
    welcome: {
      videoTitle: "Посмотрите приветственное видео",
      home: "На главную",
      title: "Добро пожаловать, {name}.",
      sub: "Твоя позиция закреплена. Эта страница — твоё подтверждение предзапуска — поделись ею со своей сетью.",
      positionLabel: "Твоя позиция",
      memberLabel: "участник сети",
      placedUnder: "Ты размещён под наставничеством",
      notFound: "Это имя пользователя ещё не зарегистрировано.",
      notFoundCta: "Регистрация",
    },
    footer: {
      tagline: "Построй один раз. Подключён навсегда.",
      disclaimer: "Страница предзапуска. Имена и цифры — иллюстративные.",
      rights: "© 2026 PreNet · The Ultimate Network",
      admin: "Админ-панель",
    },
  },
  es: {
    nav: {
      member: "Área de miembro",
      how: "Cómo funciona",
      structures: "Estructuras",
      faq: "Preguntas",
      register: "Registro gratuito",
    },
    hype: {
      eyebrow: "Por qué ahora",
      lineA: "UN PROYECTO ÚNICO.",
      lineB: "JAMÁS VISTO ANTES.",
      lineC: "TU POSICIÓN, PARA TODA LA VIDA.",
      sub: "PreNet abre la puerta a una red mundial que se construye en este momento — los primeros ya están echando raíces.",
    },
    prelaunch: {
      barBrand: "ULTIMATE PRELAUNCH",
      countdownLabel: "CUENTA ATRÁS LANZADA",
      launched: "¡YA ESTÁ LANZADO!",
      titleA: "ÚLTIMOS DÍAS PARA UNIRTE A",
      titleB: "LA POWERLINE",
      subtitle: "¡SE PREPARA UNA NUEVA AVENTURA MUNDIAL!",
      body: "En los próximos días, las primeras posiciones se asignarán manualmente en el Back Office. ¡Es el momento de tomar posición!",
      check1: "Inscripción 100 % GRATUITA",
      check2: "No se necesita ninguna compra para inscribirse",
      check3: "Comparte tu enlace de patrocinio",
      check4: "Posicionamiento en la futura estructura mundial, según las reglas del proyecto",
      reveal: "LAS PRIMERAS INFORMACIONES SE REVELARÁN:",
      chip1: "Primeros vídeos de presentación",
      chip2: "Documentos PDF explicativos",
      chip3: "Descubrimiento del Back Office",
      chip4: "Presentación progresiva del concepto internacional",
      cta: "ÚNETE A LA POWERLINE",
      share: "¡Comparte tu enlace de patrocinio e invita a tus contactos!",
      disclaimer: "Las modalidades definitivas del proyecto y las posibles remuneraciones quedan por precisar. La inscripción no garantiza ningún ingreso.",
    },
    hero: {
      eyebrow: "Pre-lanzamiento · Registro gratuito",
      liveLabel: "Nuevos miembros",
      liveNote: "Feed ilustrativo",
      urgent: "Pre-lanzamiento abierto — el orden de entrada define el posicionamiento global",
      powerlineNote: "Piénsalo, pero mientras tanto, los nuevos llegan a la powerline antes que tú!",
      realJoin: "acaba de unirse a la red",
      invitedBy: "Invitado por",
      youWillBe: "Serás",
      titleA: "Construye una vez.",
      titleB: "Conectado de por vida.",
      sub: "PreNet es la capa de comunidad. Las personas primero, las tendencias después. Toma tu posición antes de que llegue la próxima oportunidad.",
      ctaPrimary: "Registro gratuito",
      ctaSecondary: "FAQ",
      positioned: "ya posicionadas en la red",
      statStructures: "estructuras conectadas",
      statFree: "registro gratuito",
    },
    marquee: [
      "Las personas primero, las tendencias después",
      "Registro gratuito",
      "Primero la comunidad, luego las oportunidades",
      "Un registro · Cuatro estructuras",
      "Construye una vez. Conectado de por vida.",
    ],
    shift: {
      eyebrow: "Una pregunta diferente",
      title: "¿Y si la próxima tendencia no es el producto?",
      sub: "Durante años, todos esperaron el próximo gran proyecto. PreNet parte de otra pregunta: ¿qué estás construyendo antes de que llegue?",
      oldTitle: "El modelo antiguo",
      oldItems: [
        "Nueva empresa. Nuevo logo. Nueva promesa.",
        "Nuevo producto. Otra presentación que aprender.",
        "Los mismos contactos. Las mismas dudas.",
        "Construir todo desde cero. Otra vez.",
      ],
      newTitle: "PreNet cambia el orden",
      newItems: [
        "Primero la comunidad. Luego las oportunidades.",
        "Tu posición permanece cuando los proyectos cambian.",
        "Un registro, cuatro estructuras.",
        "La red ya no sigue a la oportunidad. La oportunidad llega a la red.",
      ],
      quote: "El problema nunca fue tu esfuerzo. Era el orden.",
    },
    structures: {
      eyebrow: "Un solo registro",
      title: "Múltiples estructuras.",
      sub: "Con un solo registro gratuito, PreNet te posiciona dentro de varias estructuras organizativas.",
      cards: [
        {
          name: "Matriz 3x10",
          desc: "Tres posiciones bajo cada persona y diez niveles de profundidad. Se llena nivel a nivel y organiza la profundidad.",
        },
        {
          name: "Powerline / Línea global",
          desc: "Una sola línea que crece con cada registro en el mundo. Impulsa el movimiento global.",
        },
        {
          name: "Uninivel",
          desc: "Un árbol abierto que nace en tu nodo, basado en la actividad directa.",
        },
        {
          name: "Binario",
          desc: "Dos ramas equilibradas que dan estructura a la expansión de tu equipo.",
        },
      ],
      vEyebrow: "Lo que viene",
      vTitle: "La puerta a lo que viene.",
      vSub: "PreNet se construye como la capa de comunidad para futuros lanzamientos. Tú decides qué activas.",
      vItems: [
        "Salud y bienestar",
        "Gaming y entretenimiento",
        "IA generativa",
        "Educación y experiencias",
        "Soluciones de software",
      ],
      vNote: "En preparación · Solo con opt-in",
    },
    faq: {
      eyebrow: "Preguntas reales",
      title: "Respuestas sin presión.",
      items: [
        {
          q: "¿Es otro MLM más?",
          a: "PreNet no empieza con un producto. Empieza con una comunidad que se queda contigo cuando los proyectos cambian.",
        },
        {
          q: "¿Ya llego tarde?",
          a: "La red se está formando ahora. La estructura se construye en orden, y tu posición empieza al registrarte.",
        },
        {
          q: "¿Tengo que comprar algo?",
          a: "El registro es gratuito. Cada proyecto se activa solo por opt-in, cuando tú decides.",
        },
        {
          q: "¿Y si un proyecto fracasa?",
          a: "Esa es la idea detrás de PreNet: si un proyecto cambia, la comunidad no tiene que desaparecer con él.",
        },
      ],
    },
    advantage: {
      "eyebrow": "Ventaja del pre-lanzamiento",
      "title": "El orden de entrada es la ventaja.",
      "sub": "Sin cuentas atrás, sin urgencia artificial. Un hecho: la red se construye en orden. Tu posición global empieza en el momento en que te registras — y cada registro en el mundo extiende la línea.",
      "cards": [
            {
                  "name": "Posicionamiento global",
                  "desc": "Tu lugar en la Powerline / Línea global se fija por el orden de registro. La línea crece con cada miembro, en todo el mundo."
            },
            {
                  "name": "Cuatro estructuras a la vez",
                  "desc": "Un solo registro gratuito te posiciona a la vez en la Matriz 3x10, Powerline, Uninivel y Binario."
            },
            {
                  "name": "Nada que pagar",
                  "desc": "El registro es gratuito y los futuros proyectos son solo con opt-in. Tu única inversión hoy: diez minutos."
            }
      ],
      "strip": "Sin cuenta atrás. El orden de entrada importa — asegura tu posición ahora."
},
    form: {
      eyebrow: "Tu posición",
      title: "Diez minutos. Decide.",
      sub: "El registro es gratuito. Cada proyecto es opt-in. Tu posición empieza al registrarte.",
      name: "Nombre completo",
      email: "Email",
      username: "Nombre de usuario",
      sponsor: "Usuario del patrocinador",
      sponsorOptional: "opcional",
      phName: "Alex Martín",
      phEmail: "alex@email.com",
      phUsername: "alexmartin",
      phSponsor: "el usuario de la persona que te invitó",
      country: "País",
      phCountry: "Elige un país",
      errCountry: "Elige tu país de la lista.",
      submit: "Registro gratuito",
      submitting: "Asegurando tu posición…",
      successTitle: "Posición asegurada.",
      successBody: "Bienvenido a la red. Tu nombre de usuario está reservado.",
      positionLabel: "Tu posición",
      again: "Registrar otra persona",
      shareTitle: "Corre la voz",
      shareText: "Acabo de asegurar mi posición en PreNet — registro gratuito al pre-lanzamiento. El orden de entrada importa:",
      shareCopied: "¡Enlace copiado!",
      welcomeLink: "Ver mi página de bienvenida",
      referralLinkLabel: "Tu enlace de patrocinio",
      invitedBy: "Invitado por",
      errName: "Introduce tu nombre completo.",
      errEmail: "Introduce un email válido.",
      errEmailTaken: "Este email ya está registrado.",
      errUsername: "Usuario: de 3 a 24 caracteres, letras, números o guion bajo.",
      errUsernameTaken: "Este nombre de usuario ya está en uso.",
      errSponsor: "Patrocinador inválido: de 3 a 24 caracteres, letras, números o guion bajo.",
      errGeneric: "Algo salió mal. Inténtalo de nuevo.",
      note: "Registro gratuito. Cada proyecto es opt-in. Tú decides.",
    },
    member: {
      loginTitle: "Área de miembro",
      dashLink: "Ver mis afiliados",      loginSub: "Inicia sesión con tu usuario y tu email de registro para ver tus referidos directos.",
      userLabel: "Tu usuario",
      emailLabel: "Tu email de registro",
      loginBtn: "Abrir mi panel",
      loginError: "Usuario o email desconocido. Verifica tus datos de registro.",
      dashSub: "Estas son las personas registradas con tu enlace de patrocinio:",
      yourLink: "Tu enlace de patrocinio",
      copy: "Copiar",
      copied: "¡Copiado!",
      directs: "referidos directos",
      noDirects: "Aún no hay referidos. ¡Comparte tu enlace para construir tu red!",
      colName: "Nombre",
      colEmail: "Email",
      colUsername: "Usuario",
      colCountry: "País",
      colDate: "Inscrito el",
      position: "Posición",
      refresh: "Actualizar",
      logout: "Cerrar sesión",
    },
    welcome: {
      videoTitle: "Mira el vídeo de bienvenida",
      home: "Volver al inicio",
      title: "Bienvenido, {name}.",
      sub: "Tu posición está asegurada. Esta página es tu prueba de pre-lanzamiento — compártela con tu red.",
      positionLabel: "Tu posición",
      memberLabel: "miembro de la red",
      placedUnder: "Estás colocado bajo",
      notFound: "Este nombre de usuario aún no está registrado.",
      notFoundCta: "Registro gratuito",
    },
    footer: {
      tagline: "Construye una vez. Conectado de por vida.",
      disclaimer: "Página de pre-lanzamiento. Los nombres y cifras mostrados son ilustrativos.",
      rights: "© 2026 PreNet · The Ultimate Network",
      admin: "Área admin",
    },
  },
  vi: {
    nav: {
      member: "Thành viên",
      how: "Cách hoạt động",
      structures: "Cấu trúc",
      faq: "Hỏi đáp",
      register: "Đăng ký miễn phí",
    },
    hype: {
      eyebrow: "Tại sao là ngay bây giờ",
      lineA: "MỘT DỰ ÁN ĐỘC NHẤT.",
      lineB: "CHƯA TỪNG THẤY.",
      lineC: "VỊ TRÍ CỦA BẠN, TRỌN ĐỜI.",
      sub: "PreNet mở ra cánh cửa mạng lưới toàn cầu đang được xây dựng ngay lúc này — những người đầu tiên đã tạo gốc rễ trong đó.",
    },
    prelaunch: {
      barBrand: "ULTIMATE PRELAUNCH",
      countdownLabel: "ĐẾM NGƯỢC ĐÃ BẮT ĐẦU",
      launched: "ĐÃ KHỞI ĐỘNG!",
      titleA: "NHỮNG NGÀY CUỐI ĐỂ THAM GIA",
      titleB: "POWERLINE!",
      subtitle: "MỘT CUỘC PHIÊU LƯU TOÀN CẦU MỚI ĐANG ĐƯỢC CHUẨN BỊ!",
      body: "Trong vài ngày tới, những vị trí đầu tiên sẽ được phân bổ thủ công trong Back Office. Đây là thời điểm để giữ chỗ của bạn!",
      check1: "Đăng ký 100 % MIỄN PHÍ",
      check2: "Không cần mua bất cứ thứ gì để đăng ký",
      check3: "Chia sẻ liên kết giới thiệu của bạn",
      check4: "Xếp vị trí trong cơ cấu toàn cầu tương lai, theo quy tắc của dự án",
      reveal: "NHỮNG THÔNG TIN ĐẦU TIÊN SẼ ĐƯỢC TIẾT LỘ:",
      chip1: "Những video giới thiệu đầu tiên",
      chip2: "Tài liệu PDF giải thích",
      chip3: "Khám phá Back Office",
      chip4: "Giới thiệu dần khái niệm quốc tế",
      cta: "THAM GIA POWERLINE",
      share: "Chia sẻ liên kết giới thiệu và mời bạn bè của bạn!",
      disclaimer: "Các điều khoản cuối cùng của dự án và khoản thu nhập có thể có vẫn đang được làm rõ. Việc đăng ký không đảm bảo thu nhập nào.",
    },
    hero: {
      eyebrow: "Tiền khởi động · Đăng ký miễn phí",
      liveLabel: "Thành viên mới",
      liveNote: "Dòng minh họa",
      urgent: "Tiền khởi động đã mở — thứ tự gia nhập quyết định vị trí toàn cầu",
      powerlineNote: "Cân nhắc thêm — trong lúc đó, người mới đang vào powerline trước bạn!",
      realJoin: "vừa gia nhập mạng lưới",
      invitedBy: "Được mời bởi",
      youWillBe: "Bạn sẽ là",
      titleA: "Xây một lần. ",
      titleB: "Kết nối trọn đời.",
      sub: "PreNet là tầng cộng đồng. Con người trước, xu hướng sau. Giữ vị trí của bạn trước khi cơ hội tiếp theo xuất hiện.",
      ctaPrimary: "Đăng ký miễn phí",
      ctaSecondary: "Hỏi đáp",
      positioned: "đã có vị trí trong mạng lưới",
      statStructures: "cấu trúc kết nối",
      statFree: "đăng ký miễn phí",
    },
    marquee: [
      "Con người trước, xu hướng sau",
      "Đăng ký miễn phí",
      "Cộng đồng trước, cơ hội sau",
      "Một đăng ký · Bốn cấu trúc",
      "Xây một lần. Kết nối trọn đời.",
    ],
    shift: {
      eyebrow: "Một câu hỏi khác",
      title: "Điều gì xảy ra nếu xu hướng tiếp theo không phải là sản phẩm?",
      sub: "Bao năm qua, ai cũng chờ điều lớn tiếp theo. PreNet bắt đầu từ một câu hỏi khác: bạn sẽ xây gì trước khi nó xuất hiện?",
      oldTitle: "Mô hình cũ",
      oldItems: [
        "Công ty mới. Logo mới. Lời hứa mới.",
        "Sản phẩm mới. Một bài thuyết trình mới để học.",
        "Vẫn những mối quan hệ cũ. Vẫn những hoài nghi.",
        "Xây lại tất cả từ đầu. Lần nữa.",
      ],
      newTitle: "PreNet thay đổi thứ tự",
      newItems: [
        "Cộng đồng trước. Cơ hội sau.",
        "Vị trí của bạn giữ nguyên khi dự án thay đổi.",
        "Một đăng ký, bốn cấu trúc.",
        "Mạng lưới không còn chạy theo cơ hội: cơ hội tìm đến mạng lưới.",
      ],
      quote: "Vấn đề chưa bao giờ là nỗ lực của bạn. Mà là thứ tự.",
    },
    structures: {
      eyebrow: "Một đăng ký duy nhất",
      title: "Nhiều cấu trúc.",
      sub: "Chỉ với một lần đăng ký miễn phí, PreNet đặt bạn vào nhiều cấu trúc tổ chức cùng lúc.",
      cards: [
        {
          name: "Ma trận 3x10",
          desc: "Ba vị trí dưới mỗi người, sâu mười cấp. Nó lấp đầy từng cấp và tổ chức chiều sâu.",
        },
        {
          name: "Powerline / Tuyến toàn cầu",
          desc: "Một tuyến duy nhất lớn lên cùng mỗi lần đăng ký trên toàn thế giới. Nó mang phong trào toàn cầu.",
        },
        {
          name: "Unilevel",
          desc: "Cây mở rộng từ nút của bạn, dựa trên hoạt động trực tiếp.",
        },
        {
          name: "Nhị phân",
          desc: "Hai nhánh cân bằng định hình sự mở rộng của đội ngũ bạn.",
        },
      ],
      vEyebrow: "Tiếp theo",
      vTitle: "Cánh cửa dẫn tới những gì sắp đến.",
      vSub: "PreNet được thiết kế như tầng cộng đồng của những lần ra mắt tiếp theo. Bạn quyết định điều mình kích hoạt.",
      vItems: [
        "Sức khỏe & làm đẹp",
        "Gaming & giải trí",
        "AI tạo sinh",
        "Giáo dục & trải nghiệm",
        "Giải pháp phần mềm",
      ],
      vNote: "Đang chuẩn bị · Chỉ opt-in",
    },
    faq: {
      eyebrow: "Câu hỏi thật",
      title: "Câu trả lời không áp lực.",
      items: [
        {
          q: "Lại thêm một MLM nữa à?",
          a: "PreNet không bắt đầu bằng một sản phẩm. Nó bắt đầu bằng một cộng đồng ở lại với bạn khi các dự án thay đổi.",
        },
        {
          q: "Tôi đã quá muộn rồi chứ?",
          a: "Mạng lưới đang hình thành ngay bây giờ. Cấu trúc được xây theo thứ tự, và vị trí của bạn bắt đầu khi bạn đăng ký.",
        },
        {
          q: "Tôi có phải mua gì không?",
          a: "Đăng ký miễn phí. Mỗi dự án chỉ kích hoạt theo opt-in, khi bạn quyết định.",
        },
        {
          q: "Nếu một dự án thất bại thì sao?",
          a: "Đó chính là ý tưởng của PreNet: nếu một dự án thay đổi, cộng đồng không phải biến mất theo.",
        },
      ],
    },
    advantage: {
      eyebrow: "Lợi thế tiền khởi động",
      title: "Thứ tự gia nhập chính là lợi thế.",
      sub: "Không đếm ngược, không gấp gáp giả tạo. Chỉ một sự thật: mạng lưới được xây theo thứ tự. Vị trí toàn cầu của bạn bắt đầu ngay khi đăng ký — và mỗi lần đăng ký trên thế giới tiếp nối tuyến.",
      cards: [
        {
          name: "Vị trí toàn cầu",
          desc: "Chỗ đứng của bạn trong Powerline / Tuyến toàn cầu được xác định theo thứ tự đăng ký. Tuyến lớn lên cùng từng thành viên, ở khắp mọi nơi.",
        },
        {
          name: "Bốn cấu trúc cùng lúc",
          desc: "Một lần đăng ký miễn phí đặt bạn đồng thời vào Ma trận 3x10, Powerline, Unilevel và Nhị phân.",
        },
        {
          name: "Không phải trả gì",
          desc: "Đăng ký miễn phí và các dự án tương lai chỉ opt-in. Khoản đầu tư duy nhất hôm nay của bạn: mười phút.",
        },
      ],
      strip: "Không đếm ngược. Thứ tự gia nhập quan trọng — giữ vị trí của bạn ngay bây giờ.",
    },
    form: {
      eyebrow: "Vị trí của bạn",
      title: "Mười phút. Quyết định.",
      sub: "Đăng ký miễn phí. Mỗi dự án là opt-in. Vị trí của bạn bắt đầu khi bạn đăng ký.",
      name: "Họ và tên",
      email: "Email",
      username: "Tên người dùng",
      sponsor: "Tên người dùng của người giới thiệu",
      sponsorOptional: "không bắt buộc",
      phName: "Alex Martin",
      phEmail: "alex@email.com",
      phUsername: "alexmartin",
      phSponsor: "tên người dùng của người mời bạn",
      country: "Quốc gia",
      phCountry: "Chọn quốc gia",
      errCountry: "Hãy chọn quốc gia của bạn trong danh sách.",
      submit: "Đăng ký miễn phí",
      submitting: "Đang cố định vị trí của bạn…",
      successTitle: "Vị trí đã được cố định.",
      successBody: "Chào mừng bạn vào mạng lưới. Tên người dùng của bạn đã được giữ chỗ.",
      positionLabel: "Vị trí của bạn",
      again: "Đăng ký cho người khác",
      shareTitle: "Chia sẻ nhé",
      shareText: "Tôi vừa cố định vị trí trong PreNet — đăng ký miễn phí tiền khởi động. Thứ tự gia nhập quan trọng:",
      shareCopied: "Đã sao chép liên kết!",
      welcomeLink: "Xem trang chào mừng của tôi",
      referralLinkLabel: "Liên kết giới thiệu của bạn",
      invitedBy: "Được giới thiệu bởi",
      errName: "Vui lòng nhập họ tên đầy đủ.",
      errEmail: "Vui lòng nhập email hợp lệ.",
      errEmailTaken: "Email này đã được đăng ký.",
      errUsername: "Tên người dùng: 3 đến 24 ký tự, chữ cái, số hoặc gạch dưới.",
      errUsernameTaken: "Tên người dùng này đã được sử dụng.",
      errSponsor: "Người giới thiệu không hợp lệ: 3 đến 24 ký tự, chữ cái, số hoặc gạch dưới.",
      errGeneric: "Có lỗi xảy ra. Vui lòng thử lại.",
      note: "Đăng ký miễn phí. Mỗi dự án là opt-in. Bạn quyết định.",
    },
    member: {
      loginTitle: "Khu vực thành viên",
      dashLink: "Xem người giới thiệu của tôi",      loginSub: "Đăng nhập bằng tên người dùng và email đăng ký để xem người giới thiệu trực tiếp của bạn.",
      userLabel: "Tên người dùng của bạn",
      emailLabel: "Email đăng ký của bạn",
      loginBtn: "Mở bảng của tôi",
      loginError: "Tên người dùng hoặc email không đúng. Hãy kiểm tra thông tin đăng ký của bạn.",
      dashSub: "Đây là những người đã đăng ký bằng liên kết giới thiệu của bạn:",
      yourLink: "Liên kết giới thiệu của bạn",
      copy: "Sao chép",
      copied: "Đã sao chép!",
      directs: "người giới thiệu trực tiếp",
      noDirects: "Chưa có ai trong mạng lưới. Hãy chia sẻ liên kết để xây dựng mạng lưới của bạn!",
      colName: "Tên",
      colEmail: "Email",
      colUsername: "Tên người dùng",
      colCountry: "Quốc gia",
      colDate: "Ngày đăng ký",
      position: "Vị trí",
      refresh: "Làm mới",
      logout: "Đăng xuất",
    },
    welcome: {
      videoTitle: "Xem video chào mừng",
      home: "Về trang chủ",
      title: "Chào mừng, {name}.",
      sub: "Vị trí của bạn đã được cố định. Trang này là bằng chứng tiền khởi động của bạn — hãy chia sẻ với mạng lưới của bạn.",
      positionLabel: "Vị trí của bạn",
      memberLabel: "thành viên của mạng lưới",
      placedUnder: "Bạn được đặt dưới",
      notFound: "Tên người dùng này chưa đăng ký.",
      notFoundCta: "Đăng ký miễn phí",
    },
    footer: {
      tagline: "Xây một lần. Kết nối trọn đời.",
      disclaimer: "Trang tiền khởi động. Các tên và con số hiển thị mang tính minh họa.",
      rights: "© 2026 PreNet · The Ultimate Network",
      admin: "Khu vực admin",
    },
  },
  th: {
    nav: {
      member: "สมาชิก",
      how: "วิธีการทำงาน",
      structures: "โครงสร้าง",
      faq: "คำถามที่พบบ่อย",
      register: "ลงทะเบียนฟรี",
    },
    hype: {
      eyebrow: "ทำไมต้องตอนนี้",
      lineA: "โครงการที่ไม่ซ้ำใคร",
      lineB: "ไม่เคยมีมาก่อน",
      lineC: "ตำแหน่งของคุณ ตลอดชีวิต",
      sub: "PreNet เปิดประตูสู่เครือข่ายระดับโลกที่กำลังสร้างกันอยู่ตอนนี้ — คนแรก ๆ ได้หยักรากในนั้นแล้ว",
    },
    prelaunch: {
      barBrand: "ULTIMATE PRELAUNCH",
      countdownLabel: "นับถอยหลังเริ่มแล้ว",
      launched: "เริ่มแล้ว!",
      titleA: "วันสุดท้ายที่จะเข้าร่วม",
      titleB: "POWERLINE!",
      subtitle: "การผจญภัยระดับโลกใหม่กำลังก่อตัว!",
      body: "อีกไม่กี่วันข้างหน้า ตำแหน่งแรก ๆ จะถูกจัดลงใน Back Office ด้วยตนเอง ถึงเวลาที่จะรักษาตำแหน่งของคุณแล้ว!",
      check1: "สมัครฟรี 100 %",
      check2: "ไม่ต้องซื้ออะไรเพื่อสมัคร",
      check3: "แชร์ลิงก์แนะนำของคุณ",
      check4: "จัดตำแหน่งในโครงสร้างโลกอนาคต ตามกฎของโครงการ",
      reveal: "ข้อมูลแรก ๆ จะถูกเปิดเผย:",
      chip1: "วิดีโอแนะนำชุดแรก",
      chip2: "เอกสาร PDF อธิบาย",
      chip3: "สำรวจ Back Office",
      chip4: "นำเสนอแนวคิดระดับนานาชาติอย่างต่อเนื่อง",
      cta: "เข้าร่วม POWERLINE",
      share: "แชร์ลิงก์แนะนำและเชิญผู้ติดต่อของคุณ!",
      disclaimer: "เงื่อนไขสุดท้ายของโครงการและรายได้ที่อาจเกิดขึ้นยังอยู่ระหว่างการระบุ การสมัครไม่รับประกันรายได้",
    },
    hero: {
      eyebrow: "พรีเปิดตัว · ลงทะเบียนฟรี",
      liveLabel: "สมาชิกใหม่",
      liveNote: "ฟีดตัวอย่าง",
      urgent: "พรีเปิดตัวเปิดแล้ว — ลำดับการเข้าร่วมกำหนดตำแหน่งระดับโลก",
      powerlineNote: "คิดทบทวนได้ — ระหว่างนั้น คนใหม่กำลังเข้าร่วม powerline ก่อนคุณ!",
      realJoin: "เพิ่งเข้าร่วมเครือข่าย",
      invitedBy: "ได้รับเชิญโดย",
      youWillBe: "คุณจะเป็น",
      titleA: "สร้างครั้งเดียว",
      titleB: "เชื่อมต่อตลอดชีพ",
      sub: "PreNet คือชั้นชุมชน คนมาก่อน เทรนด์ตามหลัง จับตำแหน่งของคุณก่อนโอกาสถัดไปมาถึง",
      ctaPrimary: "ลงทะเบียนฟรี",
      ctaSecondary: "คำถามที่พบบ่อย",
      positioned: "มีตำแหน่งในเครือข่ายแล้ว",
      statStructures: "โครงสร้างที่เชื่อมต่อ",
      statFree: "ลงทะเบียนฟรี",
    },
    marquee: [
      "คนมาก่อน เทรนด์ตามหลัง",
      "ลงทะเบียนฟรี",
      "ชุมชนมาก่อน โอกาสตามหลัง",
      "ลงทะเบียนครั้งเดียว · สี่โครงสร้าง",
      "สร้างครั้งเดียว เชื่อมต่อตลอดชีพ",
    ],
    shift: {
      eyebrow: "คำถามที่ต่างออกไป",
      title: "ถ้าเทรนด์ถัดไปไม่ใช่สินค้าล่ะ?",
      sub: "หลายปีที่ทุกคนรอสิ่งใหญ่ครั้งถัดไป PreNet เริ่มจากคำถามอื่น: คุณจะสร้างอะไรก่อนที่มันจะมาถึง?",
      oldTitle: "โมเดลเดิม",
      oldItems: [
        "บริษัทใหม่ โลโก้ใหม่ คำสัญญาใหม่",
        "สินค้าใหม่ พรีเซนเทชันใหม่ที่ต้องเรียนรู้",
        "คอนแทกต์เดิม ความสงสัยเดิม",
        "สร้างใหม่ทั้งหมดจากศูนย์ อีกครั้ง",
      ],
      newTitle: "PreNet เปลี่ยนลำดับ",
      newItems: [
        "ชุมชนมาก่อน แล้วโอกาสจะตามมา",
        "ตำแหน่งของคุณอยู่ครบเมื่อโปรเจกต์เปลี่ยน",
        "ลงทะเบียนครั้งเดียว สี่โครงสร้าง",
        "เครือข่ายไม่ไล่ตามโอกาสอีกต่อไป: โอกาสเดินมาหาเครือข่าย",
      ],
      quote: "ปัญหาไม่เคยใช่ความพยายามของคุณ แต่คือลำดับ",
    },
    structures: {
      eyebrow: "ลงทะเบียนครั้งเดียว",
      title: "หลายโครงสร้าง",
      sub: "ด้วยการลงทะเบียนฟรีเพียงครั้งเดียว PreNet วางคุณเข้าไปในหลายโครงสร้างองค์กรพร้อมกัน",
      cards: [
        {
          name: "เมทริกซ์ 3x10",
          desc: "สามตำแหน่งใต้แต่ละคน ลึกสิบระดับ มันเต็มทีละระดับและจัดระเบียบความลึก",
        },
        {
          name: "Powerline / สายกลางโลก",
          desc: "สายเดียวที่โตไปกับการลงทะเบียนใหม่ทั่วโลก มันนำพากระแสหลักระดับโลก",
        },
        {
          name: "ยูนิเลเวล",
          desc: "ต้นไม้เปิดที่แตกกิ่งจากโหนดของคุณ นับจากกิจกรรมสายตรง",
        },
        {
          name: "ไบนารี",
          desc: "สองกิ่งที่สมดุลกัน วางโครงการขยายทีมของคุณ",
        },
      ],
      vEyebrow: "ต่อจากนี้",
      vTitle: "ประตูสู่สิ่งที่กำลังจะมาถึง",
      vSub: "PreNet ถูกออกแบบเป็นชั้นชุมชนของการเปิดตัวครั้งถัด ๆ ไป คุณตัดสินใจเองว่าจะเปิดใช้อะไร",
      vItems: [
        "สุขภาพ & ความงาม",
        "เกม & ความบันเทิง",
        "AI เชิงสร้างสรรค์",
        "การศึกษา & ประสบการณ์",
        "โซลูชันซอฟต์แวร์",
      ],
      vNote: "อยู่ระหว่างเตรียมการ · Opt-in เท่านั้น",
    },
    faq: {
      eyebrow: "คำถามจริง",
      title: "คำตอบที่ไม่มีแรงกดดัน",
      items: [
        {
          q: "MLM อีกหนึ่งเจ้าเหรอ?",
          a: "PreNet ไม่ได้เริ่มจากสินค้า แต่เริ่มจากชุมชนที่อยู่กับคุณเมื่อโปรเจกต์เปลี่ยนไป",
        },
        {
          q: "ฉันมาช้าไปแล้วหรือยัง?",
          a: "เครือข่ายกำลังก่อตัวตอนนี้ โครงสร้างสร้างตามลำดับ และตำแหน่งของคุณเริ่มเมื่อคุณลงทะเบียน",
        },
        {
          q: "ต้องซื้ออะไรไหม?",
          a: "ลงทะเบียนฟรี แต่ละโปรเจกต์เปิดใช้ด้วย opt-in เท่านั้น เมื่อคุณตัดสินใจ",
        },
        {
          q: "ถ้าโปรเจกต์ล้มละ?",
          a: "นั่นคือแนวคิดของ PreNet: ถ้าโปรเจกต์เปลี่ยน ชุมชนไม่ต้องหายไปพร้อมกัน",
        },
      ],
    },
    advantage: {
      eyebrow: "ข้อได้เปรียบของพรีเปิดตัว",
      title: "ลำดับการเข้าคือข้อได้เปรียบ",
      sub: "ไม่มีนาฬิกานับถอยหลัง ไม่มีความเร่งรีบปลอม มีแค่ข้อเท็จจริงเดียว: เครือข่ายสร้างตามลำดับ ตำแหน่งระดับโลกของคุณเริ่มตั้งแต่ลงทะเบียน — และทุกการลงทะเบียนทั่วโลกต่อสายให้ยาวขึ้น",
      cards: [
        {
          name: "ตำแหน่งระดับโลก",
          desc: "ที่ยืนของคุณใน Powerline / สายกลางโลกถูกกำหนดด้วยลำดับการลงทะเบียน สายโตไปกับสมาชิกทุกคน ทุกที่ในโลก",
        },
        {
          name: "สี่โครงสร้างในครั้งเดียว",
          desc: "ลงทะเบียนฟรีครั้งเดียว วางคุณพร้อมกันในเมทริกซ์ 3x10, Powerline, ยูนิเลเวล และไบนารี",
        },
        {
          name: "ไม่ต้องจ่ายอะไร",
          desc: "ลงทะเบียนฟรี และโปรเจกต์ในอนาคตเป็น opt-in เท่านั้น การลงทุนเดียววันนี้ของคุณ: สิบนาที",
        },
      ],
      strip: "ไม่มีนาฬิกานับถอยหลัง ลำดับการเข้าสำคัญ — ล็อกตำแหน่งของคุณตอนนี้",
    },
    form: {
      eyebrow: "ตำแหน่งของคุณ",
      title: "สิบนาที ตัดสินใจ",
      sub: "ลงทะเบียนฟรี ทุกโปรเจกต์เป็น opt-in ตำแหน่งของคุณเริ่มเมื่อคุณลงทะเบียน",
      name: "ชื่อ-นามสกุล",
      email: "อีเมล",
      username: "ชื่อผู้ใช้",
      sponsor: "ชื่อผู้ใช้ของผู้แนะนำ",
      sponsorOptional: "ไม่บังคับ",
      phName: "Alex Martin",
      phEmail: "alex@email.com",
      phUsername: "alexmartin",
      phSponsor: "ชื่อผู้ใช้ของคนที่ชวนคุณ",
      country: "ประเทศ",
      phCountry: "เลือกประเทศ",
      errCountry: "กรุณาเลือกประเทศจากรายการ",
      submit: "ลงทะเบียนฟรี",
      submitting: "กำลังล็อกตำแหน่งของคุณ…",
      successTitle: "ล็อกตำแหน่งเรียบร้อยแล้ว",
      successBody: "ยินดีต้อนรับเข้าสู่เครือข่าย ชื่อผู้ใช้ของคุณถูกจองแล้ว",
      positionLabel: "ตำแหน่งของคุณ",
      again: "ลงทะเบียนให้คนอื่น",
      shareTitle: "บอกต่อ",
      shareText: "ฉันเพิ่งล็อกตำแหน่งใน PreNet — ลงทะเบียนฟรีพรีเปิดตัว ลำดับการเข้าสำคัญ:",
      shareCopied: "คัดลอกลิงก์แล้ว!",
      welcomeLink: "ดูหน้าต้อนรับของฉัน",
      referralLinkLabel: "ลิงก์แนะนำของคุณ",
      invitedBy: "ได้รับเชิญโดย",
      errName: "กรุณากรอกชื่อ-นามสกุลเต็ม",
      errEmail: "กรุณากรอกอีเมลที่ถูกต้อง",
      errEmailTaken: "อีเมลนี้ลงทะเบียนไว้แล้ว",
      errUsername: "ชื่อผู้ใช้: 3 ถึง 24 ตัวอักษร ตัวอักษร ตัวเลข หรือขีดล่าง",
      errUsernameTaken: "ชื่อผู้ใช้นี้ถูกใช้ไปแล้ว",
      errSponsor: "ผู้แนะนำไม่ถูกต้อง: 3 ถึง 24 ตัวอักษร ตัวอักษร ตัวเลข หรือขีดล่าง",
      errGeneric: "เกิดข้อผิดพลาด กรุณาลองใหม่",
      note: "ลงทะเบียนฟรี ทุกโปรเจกต์เป็น opt-in คุณตัดสินใจเอง",
    },
    member: {
      loginTitle: "พื้นที่สมาชิก",
      dashLink: "ดูผู้สมัครของฉัน",      loginSub: "เข้าสู่ระบบด้วยชื่อผู้ใช้และอีเมลที่ใช้สมัครเพื่อดูผู้สมัครโดยตรงของคุณ",
      userLabel: "ชื่อผู้ใช้ของคุณ",
      emailLabel: "อีเมลที่ใช้สมัครของคุณ",
      loginBtn: "เปิดแดชบอร์ดของฉัน",
      loginError: "ไม่พบชื่อผู้ใช้หรืออีเมล โปรดตรวจสอบข้อมูลการสมัครของคุณ",
      dashSub: "นี่คือผู้ที่สมัครผ่านลิงก์แนะนำของคุณ:",
      yourLink: "ลิงก์แนะนำของคุณ",
      copy: "คัดลอก",
      copied: "คัดลอกแล้ว!",
      directs: "ผู้สมัครโดยตรง",
      noDirects: "ยังไม่มีผู้สมัคร แชร์ลิงก์ของคุณเพื่อสร้างเครือข่าย!",
      colName: "ชื่อ",
      colEmail: "อีเมล",
      colUsername: "ชื่อผู้ใช้",
      colCountry: "ประเทศ",
      colDate: "วันที่สมัคร",
      position: "ตำแหน่ง",
      refresh: "รีเฟรช",
      logout: "ออกจากระบบ",
    },
    welcome: {
      videoTitle: "ดูวิดีโอต้อนรับ",
      home: "กลับหน้าหลัก",
      title: "ยินดีต้อนรับ, {name}",
      sub: "ตำแหน่งของคุณล็อกเรียบร้อย หน้านี้คือหลักฐานพรีเปิดตัวของคุณ — แชร์ไปกับเครือข่ายของคุณได้เลย",
      positionLabel: "ตำแหน่งของคุณ",
      memberLabel: "สมาชิกของเครือข่าย",
      placedUnder: "คุณถูกวางอยู่ภายใต้",
      notFound: "ชื่อผู้ใช้นี้ยังไม่ได้ลงทะเบียน",
      notFoundCta: "ลงทะเบียนฟรี",
    },
    footer: {
      tagline: "สร้างครั้งเดียว เชื่อมต่อตลอดชีพ",
      disclaimer: "หน้าพรีเปิดตัว ชื่อและตัวเลขที่แสดงเป็นเพียงตัวอย่าง",
      rights: "© 2026 PreNet · The Ultimate Network",
      admin: "พื้นที่แอดมิน",
    },
  },
  hr: {
    nav: {
      member: "Članski prostor",
      how: "Kako funkcionira",
      structures: "Strukture",
      faq: "FAQ",
      register: "Besplatna registracija",
    },
    hype: {
      eyebrow: "Zašto upravo sada",
      lineA: "JEDINSTVEN PROJEKT.",
      lineB: "NEVIĐEN DO SADA.",
      lineC: "VAŠA POZICIJA, ZA CIJELI ŽIVOT.",
      sub: "PreNet otvara vrata globalnoj mreži koja se gradi upravo sada — prvi stižu prvi i ukorijenjuju se u njoj.",
    },
    prelaunch: {
      barBrand: "ULTIMATE PRELAUNCH",
      countdownLabel: "ODBROJAVANJE JE POČELO",
      launched: "POČELO JE!",
      titleA: "POSLJEDNJI DANI ZA PRIDRUŽIVANJE",
      titleB: "POWERLINE-U!",
      subtitle: "PRIPREMA SE NOVA GLOBALNA AVANTURA!",
      body: "U sljedećih nekoliko dana prve pozicije dodijelit će se ručno u Back Officeu. Sada je trenutak da zauzmete svoju poziciju!",
      check1: "Registracija 100 % BESPLATNA",
      check2: "Za registraciju nije potrebna kupnja",
      check3: "Podijelite svoj preporučni link",
      check4: "Pozicioniranje u budućoj globalnoj strukturi, prema pravilima projekta",
      reveal: "PRVE INFORMACIJE BIT ĆE OBJAVLJENE:",
      chip1: "Prvi promotivni videi",
      chip2: "Objašnjavajući PDF dokumenti",
      chip3: "Otkrivanje Back Officea",
      chip4: "Postupno predstavljanje međunarodnog koncepta",
      cta: "PRIDRUŽITE SE POWERLINE-U",
      share: "Podijelite svoj preporučni link i pozovite svoje kontakte!",
      disclaimer: "Konačni uvjeti projekta i eventualne isplate ostaju za precizirati. Registracija ne jamči nikakav prihod.",
    },
    hero: {
      eyebrow: "Predstart · Besplatna registracija",
      liveLabel: "Novi članovi",
      liveNote: "Ilustrativni prikaz",
      urgent: "Predstart otvoren — red dolaska određuje globalni položaj",
      powerlineNote: "Razmislite, ali u međuvremenu novi stižu u powerline prije vas!",
      realJoin: "upravo se pridružio mreži",
      invitedBy: "Pozvao",
      youWillBe: "Bit ćete",
      titleA: "Izgradi jednom.",
      titleB: "Povezan zauvijek.",
      sub: "PreNet je zajednički sloj. Ljudi prvo, trendovi poslije. Zauzmite svoju poziciju prije nego što stigne sljedeća prilika.",
      ctaPrimary: "Besplatna registracija",
      ctaSecondary: "FAQ",
      positioned: "već pozicioniranih u mreži",
      statStructures: "povezanih struktura",
      statFree: "besplatna registracija",
    },
    marquee: [
      "Ljudi prvo, trendovi poslije",
      "Besplatna registracija",
      "Zajednica prvo, prilike poslije",
      "Jedna registracija · Četiri strukture",
      "Izgradi jednom. Povezan zauvijek.",
    ],
    shift: {
      eyebrow: "Drugačije pitanje",
      title: "A ako sljedeći trend nije proizvod?",
      sub: "Godinama su svi čekali sljedeću veliku stvar. PreNet polazi od drugog pitanja: što gradite prije nego što stigne?",
      oldTitle: "Stari model",
      oldItems: [
        "Nova tvrtka. Novi logo. Novo obećanje.",
        "Novi proizvod. Nova prezentacija za naučiti.",
        "Isti kontakti. Iste sumnje.",
        "Sve izgraditi ispočetka. Opet.",
      ],
      newTitle: "PreNet mijenja redoslijed",
      newItems: [
        "Zajednica prvo. Prilike poslije.",
        "Vaša pozicija ostaje kada se projekti mijenjaju.",
        "Jedna registracija, četiri strukture.",
        "Mreža više ne slijedi priliku: prilika dolazi k mreži.",
      ],
      quote: "Problem nikada nije bio vaš trud. Bio je to redoslijed.",
    },
    structures: {
      eyebrow: "Samo jedna registracija",
      title: "Više struktura.",
      sub: "S jednom besplatnom registracijom PreNet vas pozicionira u više organizacijskih struktura.",
      cards: [
        {
          name: "Matrica 3x10",
          desc: "Tri pozicije pod svakom osobom, deset razina dubine. Punila se razinu po razinu i organizira dubinu.",
        },
        {
          name: "Powerline / Globalna linija",
          desc: "Jedna linija koja raste sa svakom registracijom u svijetu. Ona nosi globalni pokret.",
        },
        {
          name: "Uninivo",
          desc: "Otvoreno stablo koje polazi od vašeg čvora, temeljeno na izravnoj aktivnosti.",
        },
        {
          name: "Binarna struktura",
          desc: "Dvije uravnotežene grane koje strukturiraju ekspanziju vašeg tima.",
        },
      ],
      vEyebrow: "Nastavak",
      vTitle: "Vrata prema onome što dolazi.",
      vSub: "PreNet je dizajniran kao zajednički sloj budućih lansiranja. Vi odlučujete što ćete aktivirati.",
      vItems: [
        "Zdravlje & dobrobit",
        "Gaming & zabava",
        "Generativna UI",
        "Obrazovanje & iskustva",
        "Softverska rješenja",
      ],
      vNote: "U pripremi · Samo po izboru",
    },
    faq: {
      eyebrow: "Prava pitanja",
      title: "Odgovori bez pritiska.",
      items: [
        {
          q: "Još jedan MLM?",
          a: "PreNet ne počinje s proizvodom. Počinje sa zajednicom koja ostaje s vama kada se projekti mijenjaju.",
        },
        {
          q: "Je li već prekasno?",
          a: "Mreža se formira sada. Struktura se gradi redoslijedom, a vaša pozicija počinje kada se registrirate.",
        },
        {
          q: "Moram li nešto kupiti?",
          a: "Registracija je besplatna. Svaki se projekt aktivira samo po izboru, kada vi odlučite.",
        },
        {
          q: "A ako projekt propadne?",
          a: "To je ideja iza PreNeta: ako se projekt promijeni, zajednica ne mora nestati s njim.",
        },
      ],
    },
    advantage: {
      "eyebrow": "Prednost predstarta",
      "title": "Red dolaska je prednost.",
      "sub": "Bez odbrojavanja, bez umjetne hitnosti. Jedina činjenica: mreža se gradi redoslijedom. Vaša globalna pozicija počinje registracijom — a svaka registracija u svijetu produžava liniju.",
      "cards": [
            {
                  "name": "Globalna pozicija",
                  "desc": "Vaše mjesto u Powerlineu / Globalnoj liniji određuje redoslijed registracije. Linija raste sa svakim članom, svugdje u svijetu."
            },
            {
                  "name": "Četiri strukture odjednom",
                  "desc": "Jedna besplatna registracija pozicionira vas istovremeno u Matricu 3x10, Powerline, Uninivo i Binarnu strukturu."
            },
            {
                  "name": "Ništa za platiti",
                  "desc": "Registracija je besplatna, a budući projekti isključivo po izboru. Vaša jedina investicija danas: deset minuta."
            }
      ],
      "strip": "Bez odbrojavanja. Red dolaska se računa — osigurajte svoju poziciju sada."
},
    form: {
      eyebrow: "Vaša pozicija",
      title: "Deset minuta. Odlučite.",
      sub: "Registracija je besplatna. Svaki projekt je po izboru. Vaša pozicija počinje kada se registrirate.",
      name: "Puno ime",
      email: "Email",
      username: "Korisničko ime",
      sponsor: "Korisničko ime podupiratelja",
      sponsorOptional: "neobavezno",
      phName: "Alex Martin",
      phEmail: "alex@email.com",
      phUsername: "alexmartin",
      phSponsor: "korisničko ime osobe koja vas je pozvala",
      country: "Zemlja",
      phCountry: "Odaberite zemlju",
      errCountry: "Odaberite svoju zemlju s popisa.",
      submit: "Besplatna registracija",
      submitting: "Osiguravanje vaše pozicije…",
      successTitle: "Pozicija osigurana.",
      successBody: "Dobro došli u mrežu. Vaše korisničko ime je rezervirano.",
      positionLabel: "Vaša pozicija",
      again: "Registrirajte drugu osobu",
      shareTitle: "Podijelite",
      shareText: "Upravo sam osigurao svoju poziciju u PreNetu — besplatna registracija za predstart. Red dolaska se računa:",
      shareCopied: "Link kopiran!",
      welcomeLink: "Pogledajte moju dobrodošlicu",
      referralLinkLabel: "Vaš preporučni link",
      invitedBy: "Pozvao",
      errName: "Unesite svoje puno ime.",
      errEmail: "Unesite valjanu email adresu.",
      errEmailTaken: "Ovaj email je već registriran.",
      errUsername: "Korisničko ime: 3 do 24 znaka, slova, brojevi ili podvlaka.",
      errUsernameTaken: "Ovo korisničko ime je već zauzeto.",
      errSponsor: "Nevažeći podupiratelj: 3 do 24 znaka, slova, brojevi ili podvlaka.",
      errGeneric: "Došlo je do pogreške. Pokušajte ponovno.",
      note: "Besplatna registracija. Svaki projekt je po izboru. Vi odlučujete.",
    },
    member: {
      loginTitle: "Članski prostor",
      dashLink: "Moji partneri",
      loginSub: "Prijavite se svojim korisničkim imenom i emailom registracije da vidite svoje izravne partnere.",
      userLabel: "Vaše korisničko ime",
      emailLabel: "Vaš email registracije",
      loginBtn: "Otvori moju ploču",
      loginError: "Nepoznato korisničko ime ili email. Provjerite svoje podatke registracije.",
      dashSub: "Ovo su osobe registrirane vašim preporučnim linkom:",
      yourLink: "Vaš preporučni link",
      copy: "Kopiraj",
      copied: "Kopirano!",
      directs: "izravnih partnera",
      noDirects: "Još nema partnera. Podijelite svoj link i gradite svoju mrežu!",
      colName: "Ime",
      colEmail: "Email",
      colUsername: "Korisničko ime",
      colCountry: "Zemlja",
      colDate: "Registriran",
      position: "Pozicija",
      refresh: "Osvježi",
      logout: "Odjava",
    },
    welcome: {
      videoTitle: "Pogledajte video dobrodošlice",
      home: "Povratak na početnu",
      title: "Dobro došli, {name}.",
      sub: "Vaša pozicija je osigurana. Ova stranica je vaš dokaz predstarta — podijelite je sa svojom mrežom.",
      positionLabel: "Vaša pozicija",
      memberLabel: "član mreže",
      placedUnder: "Smješteni ste pod",
      notFound: "Ovo korisničko ime još nije registrirano.",
      notFoundCta: "Besplatna registracija",
    },
    footer: {
      tagline: "Izgradi jednom. Povezan zauvijek.",
      disclaimer: "Stranica predstarta. Prikazani nazivi i brojevi su ilustrativni.",
      rights: "© 2026 PreNet · The Ultimate Network",
      admin: "Administracija",
    },
  },
};
